<div class="scroll-progress-container">
  <div class="scroll-progress-bar"></div>
</div>
<div class="blog-container" scrollProgress>
  @if (activeHeaderImg) {
    <div
      class="main-image animated fadeIn"
      [ngStyle]="{
        background:
          'linear-gradient(#1B9AC6 25%, transparent), url(' +
          activeHeaderImg +
          ') center no-repeat',
        'background-size': 'cover',
      }"
    >
      <div class="container">
        <h1>
          {{ 'PAGES.BLOG.TITLE' | translate }}
        </h1>
        <span class="cen">
          <p>{{ 'PAGES.BLOG.DESC' | translate }}</p>
        </span>
        <!-- Filter Blogs by Cat -->
        @if (blogCategoryList && blogCategoryList.length) {
          <div class="blog-categories">
            <div class="cat_outer">
              <button
                class="cat_button"
                [class.selected]="!selectedFilteredCatId"
                (click)="resetFilter()"
              >
                All
              </button>
              @for (cat of blogCategoryList; track cat.catId) {
                <button
                  class="cat_button"
                  [class.selected]="selectedFilteredCatId === cat.catId"
                  (click)="selectableBlogCat(cat.catId)"
                >
                  {{ cat.catName }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <div class="outer-container">
    <div class="main-blog-container">
      @if (isFetching) {
        @for (i of [1, 2, 3]; track i) {
          <div class="blog-card isLoading"></div>
        }
      } @else if (filteredBlogList?.length) {
        @for (blog of filteredBlogList; track blog.id) {
          <div class="blog-card animated fadeIn" [id]="blog.id">
            <div class="image-container">
              <a [routerLink]="['/blog', blog.newSlug || blog.slug]">
                <img
                  [ngSrc]="blog.imgUrl || defaultImage"
                  [height]="CARD_HEIGHT"
                  [width]="CARD_WIDTH"
                  [alt]="blog.title"
                  class="blog-img"
                />
              </a>
            </div>

            <div class="post-content">
              <div class="post-details">
                <div class="inner">
                  <p class="date">{{ blog.date | date }}</p>
                  <p>{{ blog.catName }}</p>
                </div>

                <a [routerLink]="['/blog', blog.newSlug || blog.slug]">
                  <h3 class="post-title">
                    {{ blog.title }}
                  </h3>
                </a>
                <!-- Only show excerpt if it exists -->

                @if (blog.excerpt) {
                  <p class="snippet">
                    {{ getPlainTextExcerpt(blog.excerpt) }}
                  </p>
                } @else {
                  <p class="snippet no-excerpt">
                    {{ 'COMPONENTS.BLOG.SNIPPET_FALLBACK' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="no-results">
          <p>{{ 'PAGES.BLOG.NO_POSTS' | translate }}</p>
        </div>
      }
    </div>
  </div>

  <app-lp-footer></app-lp-footer>
</div>
